import { useMutation } from '@tanstack/react-query';
import { updateSMSTemplateById } from '../../../shared/services';
const useUpdateSMSTemplateById = () => {
    return useMutation({
        mutationFn: async ({ id, data, }) => {
            console.log('id', id);
            return await updateSMSTemplateById(id, data);
        },
    });
};
export default useUpdateSMSTemplateById;
